/* eslint-disable */

import { entryService, customerService } from '../_services'
import router from '../_router'
import { EventBus } from '@/event-bus.js'
import { store } from '../_store';
import { sendToMixPanel } from '@/_utilities/seerMixPanel';
import { MIXPANEL_EVENTS } from '../_utilities/Enums';

const state = {
  count: 0,
  items: [],
  settings: {},
  item: {},
  draggable: true,
  status: 'idle', // loading, idle, complete, error
  emailStatus: null,
  outlookStatus: null,
  gmailStatus: null,
  preview: '',
  isLoading: false,
  cloningItems: [],
  savingAsTemplateItems: [],
  summaryItem: {},
  isTextFocused: false,
}

var subd = (dict, keys) =>{
  var r = {}
  for (var k of keys){
    r[k] = dict[k]
  }
  return r
}

var ref = (object) => {
  /**
   * Converts a dictionary unto a URL reference
   * and a Array into an array of references
   */
  if (Array.isArray(object)){
    return object.map( x => x.url)
  }else if (typeof object === "object"){
    return object.url
  }else{
    console.error("Attempt to reference ...")
  }
}

const actions = {
 async fetchAll({ commit }, args = null){
    commit('setIsLoading', true)
    const response = await entryService.getItems(args)
    commit('updateItems', response.data.results);
    commit('updateCount', response.data.count);
    commit('setIsLoading', false)
  },
  async fetchData({ commit, dispatch }, id) {
    commit('setIsLoading', true)
    commit('updateStatus', 'loading')
    commit('updateData', {})
    try {
      let response = await entryService.getItem(id)
      if (response) {
        commit('updateData', response.data)
        commit('updateSettings', {})

        setTimeout(() => {
          commit('updateStatus', 'complete')
        }, 500)
      }
    }
    catch (e) {
      commit('updateStatus', 'error')
    }
    finally {
      commit('setIsLoading', false)
    }
  },
  addPage({commit}, args = null) {
    commit('setIsLoading', true)
    return entryService.getItems(args).then(response => {
      commit('addItems', response.data.results)
      commit('updateCount', response.data.count)
      return response
    })
    .finally(() => {
      commit('setIsLoading', false)
    })
  },
  cloneItem({commit}, id){
    commit('addToCloningList', id)
    return entryService.cloneItem(id).then((r) => {
      sendToMixPanel(MIXPANEL_EVENTS.editCreated, {
        account_id: store.state.account.user.user.email,
        edit_id: r.data.pk,
        source: "duplicate",
      });
      EventBus.$emit('duplicateReady', r.data)
      return r
    }).finally(() => {
      commit('removeFromCloningList', id)
    })
  },
  cloneAsTemplate({ commit }, id) {
    commit('addToSavingAsTemplateList', id)
    return entryService.cloneAsTemplate(id).then((response) => response).finally(() => {
      commit('removeFromSavingAsTemplateList', id)
    })
  },
  newItem({ commit }, appointment = null){
    commit('reset');
    var payload= {
      subject: ''
    }
    commit('setIsLoading', true)
    entryService.postItem(payload, appointment).then((r) => {
      sendToMixPanel(MIXPANEL_EVENTS.editCreated, {
        account_id: store.state.account.user.user.email,
        edit_id: r.data.pk,
      });
      router.push(`/entries/${r.data.pk}/edit`)
    }).catch(() => {
      EventBus.$emit('toast-error', 'There\'s been an error creating a new Edit, please try again in a few seconds.')
    }).finally(() => {
      commit('setIsLoading', false)
    })
  },
  editPublished({ commit }, item) {
    return new Promise((resolve, reject) => {
      entryService.patchItem(item).then(res => {
        resolve(res.data);
      }).catch((error) => {
        console.log("error ==>", error)
      });
    })
  },
  deleteItem({commit}, id){
    entryService.deleteItem(id).then((r) => {
      commit('deleteItem', id)
    })
  },
  likeItem({commit}, id){
    entryService.likeItem(id).then((response) => {
      commit('likedItem', response.data.edit)
    })
  },

  unlikeItem({commit}, id){
    entryService.unlikeItem(id).then((response) => {
      commit('likedItem', response.data.edit)
    })
  },

  changeTemplateStatus({state, commit}, {id, isTemplate}) {
    commit('updateStatus', 'saving')
    const item = { url: state.items.find((e) => e.pk === id).url, is_template: isTemplate }
    return new Promise(( resolve, reject ) => {
      entryService.patchItem(item).then(response => {
        commit('updateStatus', 'complete')
        resolve()
        setTimeout(() => {
          commit('updateStatus', 'idle')
        }, 500)
      }).catch(e =>{
        commit('updateStatus', 'item-error')
        reject(e)
      })
    })
  },
  saveItem({state, commit}, fields = null){
    commit('updateStatus', 'saving')
    // Shallow copy so we can modify
    var item = Object.assign({},state.item)
    if (fields != null)
      item = subd(item, fields)
    item.to_customers = ref(item.to_customers)
    item.to_groups = ref(item.to_groups)
    return new Promise(( resolve, reject ) => {
      entryService.patchItem(item).then(response => {
        commit('updateStatus', 'complete')
        
        if(fields != null){        
          if (fields.includes('sections')){
            commit('updateDataSections', response.data.sections)
          }
        }
        //commit('updateData', response.data)
        resolve()
        setTimeout(() => {
          commit('updateStatus', 'idle')
        }, 500)
      }).catch(e =>{
        commit('updateStatus', 'item-error')
        reject(e)
      })
    })
  },
  updateCurrentItem({commit}, item){
    commit('updateData', item)
  },
  sendEmail({commit, state, dispatch}, {test_payload, scheduleISO}){
    commit('updateEmailStatus', 'sending');
    dispatch('saveItem').then(() => {
      entryService.sendEmail(state.item.pk, test_payload, scheduleISO).then( () => {
        if (Object.keys(test_payload).length === 0){
          commit('updateEmailStatus', 'sent');
        }else{
          commit('updateEmailStatus', 'sent_test');
        }
      })
      .catch( (e) => {
        var message = null
        try{ 
          message = e.response.data.detail
          commit('updateEmailStatusMessage', message);
        }catch{
          
        }
        commit('updateEmailStatus', 'error');
        
      });
    })
  },
  sendOutlook({commit, state, dispatch}, {test_payload = {}, scheduleISO=null}){
    commit('updateOutlookStatus', 'sending')
    dispatch('saveItem').then(() => {
      entryService.sendOutlook(state.item.pk, test_payload, scheduleISO).then( () => {
        if (Object.keys(test_payload).length === 0){
          commit('updateOutlookStatus', 'sent');
        }else{
          commit('updateOutlookStatus', 'sent_test');
        }
        
      })
      .catch( () => {
        commit('updateOutlookStatus', 'error');
      });
    })
  },
  sendGmail({commit, state, dispatch}, {authCode, test_payload = {},scheduleISO=null}){
    commit('updateGmailStatus', 'sending')
    dispatch('saveItem').then(() => {
      entryService.sendGmail(state.item.pk, {code: authCode, ...test_payload}, scheduleISO).then( () => {
        if (Object.keys(test_payload).length === 0){
          commit('updateGmailStatus', 'sent');
        }else{
          commit('updateGmailStatus', 'sent_test');
        }
        
      })
      .catch( () => {
        commit('updateGmailStatus', 'error');
      });
    })
  },
  getPreview({ commit }, args) {
    commit('updatePreview', '')
    commit('setIsLoading', true)
    entryService.getPreview(args.id, args.intro).then(r => {
      commit('updatePreview', r.data)
    }).catch((e) => {
      console.log(e)
    }).finally(() => {
      commit('setIsLoading', false)
    })
  },
  /** Update editorial recipients.
      * Creates customers in backend for all new emails
      * LOCALLY update recipients. User of this method is responsible for actually patching on backend on promise resolve.
   **/
  updateTo({commit}, {toCustomers, toGroups}){
    commit("updateToCustomers", toCustomers)
    commit('updateToGroups', toGroups)
  },
  getSentSummary({commit}, id){
    commit('setIsLoading', true)
    entryService.getSentSummary(id).then((response) => {
      commit('updateSentSummary', response.data)
    }).finally(() => {
      commit('setIsLoading', false)
    })
  },
  reset({commit}){
    commit('reset')
  },
  renderForWechat({ commit }, id) {
    return new Promise((resolve, reject) => {
      entryService.renderForWechat(id)
      resolve()
    })
  }
}


const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  reset: () => { },
  updateToCustomers(state, to_customers){
    state.item.to_customers = to_customers
  },
  deleteItem(state, pk){
    state.items = state.items.filter(item => item.pk != pk)
		state.count = state.count - 1
  },
  likedItem(state, editItem){
    const items = state.items;
    const ids = items.map(item => item.pk);
    const index = ids.indexOf(editItem.pk);
    const item = state.items.find(item => item.pk === item.pk);
    items = items.splice(index, 1, {...item, ...editItem});
    state.items = items;
  },
  addItem(state, item){
    state.items.unshift(item)
  },
  addItems(state, items) {
    state.items.push(...items)
  },
  updateToGroups(state, to_groups){
    state.item.to_groups = to_groups
  },
  updateCount(state, count) {
    state.count = count
  },
  updateItemError(state, item_error) {
    state.item_error = item_error
  },
  updateItems(state, items){
    state.items = items
  },
  updateData(state, item) {
    state.item = item
  },
  updatePublished(state, published) {
    state.item.published = published
  },
  updateDataSections(state, sections) {
    state.item.sections = sections
  },
  updateSections(state, sections) {
    state.item.sections = sections
  },
  updateSettings(state, settings) {
    state.settings = settings
  },
  updateStatus(state, status){
    state.status = status
  },
  updateEmailStatus(state, status, message = null){
    state.emailStatus = status
  },
  updateEmailStatusMessage(state, message = null){
    state.emailStatusMessage = message
  },
  updateGmailStatus(state, status,  message = null){
    state.gmailStatus = status
  },
  updateOutlookAuthUrl(state, url) {
    state.outlookAuthUrl = url
  },
  updateOutlookStatus(state, status,  message = null){
    state.outlookStatus = status
  },
  updatePreview(state, preview){
    state.preview = preview
  },
  updateDragglable(state, draggable){
    state.draggable = draggable
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  addToCloningList(state, id) {
    state.cloningItems.push(id);
  },
  removeFromCloningList(state, id) {
    state.cloningItems = state.cloningItems.filter(x => x !== id);
  },
  addToSavingAsTemplateList(state, id) {
    state.savingAsTemplateItems.push(id);
  },
  removeFromSavingAsTemplateList(state, id) {
    state.savingAsTemplateItems = state.savingAsTemplateItems.filter(x => x !== id)
  },
  updateSentSummary(state, data) {
    state.summaryItem = data
  },
};

export const entries = {
  namespaced: true,
  state,
  actions,
  mutations
}
